module.exports = __webpack_public_path__ + "img/mask-img2.99ab6fb7.png";